import { ViewMode, TViewMode } from "src/components/pages/search/store/search-store";
import { SELECTED_EXTENDED_SEARCH_VIEW_MODE } from "src/constants/local-storage";
import { localStorage } from "src/utils/storage";

export const saveViewMode = (view: TViewMode) => {
    localStorage.set(SELECTED_EXTENDED_SEARCH_VIEW_MODE, view);
};

export const loadViewMode = (): TViewMode | null => {
    const savedView = localStorage.get<TViewMode>(SELECTED_EXTENDED_SEARCH_VIEW_MODE);

    if (savedView === ViewMode.Grid || savedView === ViewMode.Table) {
        return savedView;
    }

    return null;
};
